<template>
  <el-container class="meeting-room" id="meeting-room">
    <el-aside v-if="false" width="200px">Aside</el-aside>
    <el-container>
      <el-header v-if="false">Header</el-header>
      <el-main class="main-content">
        <el-row style="border-radius: 12px;" :style="{height:((hideControls || landscapeMode) ? '100%':'90%'),'margin-bottom':(hideControls ? '0':'1em')}" v-loading="remoteLoading" element-loading-text="Connecting..." element-loading-spinner="el-icon-loading" element-loading-fullscreen="false">

          <div id="recording-text" v-show="recording">
            <i class="fa fa-circle blink" style="color: red; width: 0.8em"></i>
          </div>
          <el-row class="height-100">
            <el-col :span="24" class="height-100">
              <div id="remoteHolder"></div>
            </el-col>
          </el-row>
          <el-row class="video-strip" v-show="!hideControls">
            <el-col class="width-100">
              <el-card class="localHolder-card" :style="{width:(landscapeMode ? '13vw':'')}" :body-style="{ padding: '0px', position: 'relative' }">
                <div id="local-holder-overlay" class="height-100 width-100">
                  <i class="fa fa-video-slash" style="
                    display: block;
                    margin: auto;
                    height: 80%;
                    color: white;
                  " v-show="videoMuted" />
                </div>
                <div id="localHolder" :style="{height:landscapeMode ? '100%':'22vh'}" class="video" v-loading="localLoading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-fullscreen="false"></div>
              </el-card>
            </el-col>
          </el-row>
        </el-row>

        <el-row class="controls" style="position:absolute;" :class="{ 'control-floored': controlPositionFloored }" v-if="controlsEnabled && !hideControls">
          <el-button :type="audioMuted ? 'danger' : 'info'" @click="toggleMuteAudio" circle>
            <i class="fa" style="width:1em;" :class="!audioMuted ? 'fa-microphone' : 'fa-microphone-slash'"></i>
          </el-button>

          <el-button :type="videoMuted ? 'danger' : 'info'" @click="toggleMuteVideo" circle>
            <i class="fa" :class="videoMuted ? 'fa-eye-slash' : 'fa-eye'"></i>
          </el-button>
        </el-row>

      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import SimpleMeetingsWebex from "@teslontechnologies/simplemeetings-core-webex";

export default {
  name: "webex-teams",
  props: ["query", "hideControls"],
  data() {
    return {
      device: device,
      simpleMeetingsWebex: {},
      isMobile: false,
      facingMode: "user",
      layout: {
        presenting: false,
        videoSpeaker: true,
        videoMosaic: false,
        fullscreen: false,
      },
      recording: false,
      remoteLoading: true,
      localLoading: true,
      notificationHandle: {
        close() {},
      },
      landscapeMode: false,
    };
  },
  mounted: function () {
    const remoteMediaContainerSelector = "#remoteHolder";
    const localMediaContainerSelector = "#localHolder";
    this.simpleMeetingsWebex = new SimpleMeetingsWebex(this.query);
    window.simpleMeetingsWebex = this.simpleMeetingsWebex;

    this.simpleMeetingsWebex.setLocalMediaContainerSelector(
      localMediaContainerSelector
    );
    this.simpleMeetingsWebex.setRemoteMediaContainerSelector(
      remoteMediaContainerSelector
    );

    this.simpleMeetingsWebex.eventEmitter.on("localMediaAdded", () => {
      this.localLoading = false;
    });

    this.simpleMeetingsWebex.eventEmitter.on("remoteMediaAdded", () => {
      this.remoteLoading = false;
    });

    //Initializing electron manager
    // this.electronManager = new ElectronManager(simpleMeetingsWebex);

    this.isMobile = this.simpleMeetingsWebex.isMobile();
    if (this.isMobile) this.facingMode = "user";

    this.simpleMeetingsWebex.webexManager.initCall();

    if (
      window &&
      window.screen &&
      window.screen.orientation &&
      window.screen.orientation.type &&
      (window.screen.orientation.type == "landscape-primary" ||
        window.screen.orientation.type == "landscape-secondary")
    ) {
      this.landscapeMode = true;
    } else {
      this.landscapeMode = false;
    }

    window.onorientationchange = () => {
      if (
        window.screen.orientation.type == "landscape-primary" ||
        window.screen.orientation.type == "landscape-secondary"
      ) {
        this.landscapeMode = true;
      } else {
        this.landscapeMode = false;
      }
    };
  },

  methods: {
    toggleMuteAudio() {
      this.simpleMeetingsWebex.webexManager.toggleMuteAudio();
    },
    toggleMuteVideo() {
      this.simpleMeetingsWebex.webexManager.toggleMuteVideo();
    },
  },
  computed: {
    audioMuted() {
      return (
        this.simpleMeetingsWebex.webexManager
          ? this.simpleMeetingsWebex.webexManager.audioMuted
          : false
      )
        ? true
        : false;
    },
    videoMuted() {
      return this.simpleMeetingsWebex.webexManager &&
        this.simpleMeetingsWebex.webexManager.videoMuted
        ? true
        : false;
    },
    controlPositionFloored() {
      return this.simpleMeetingsWebex.userManager &&
        this.simpleMeetingsWebex.userManager.mode == "sfu" &&
        !this.layout.videoMosaic
        ? false
        : true;
    },
    controlsEnabled() {
      return this.simpleMeetingsWebex.controlsEnabled;
    },
  },
};
</script>

<style scoped>
.meeting-room {
  height: 100%;
  width: 100%;
  margin: 0px;
}
.meeting-room .main-content {
  padding-left: 1em;
  padding-right: 1em;
  padding-top: 1em;
  background-color: #606266;
}

#recording-text {
  position: absolute;
  z-index: 1;
  font-weight: 600;
  font-size: 1.2em;
  color: white;
  padding: 10px;
}
.controls {
  position: fixed;
  bottom: 15%;
  width: 75%;
  left: 50%;
  margin-left: -37.5%;
  z-index: 2000; /* to come behind .swal2-container */
}

.control-floored {
  bottom: 2%;
}

.layout-controls {
  position: fixed;
  top: 1em;
  width: 10%;
  inset-inline-end: 1em;
  z-index: 9999999;
}
.layout-buttons {
  padding: 5px;
}

.meeting-settings-controls {
  position: fixed;
  top: 1em;
  width: 10%;
  left: 1em;
  z-index: 9999999;
}
.settings-buttons {
  padding: 5px !important;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.main-content {
  position: relative;
  overflow: hidden;
}
.video-strip {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1999;
  border-radius: 12px;
  box-shadow: 0 0 20px black;
}
/deep/#remoteHolder {
  position: absolute;
  top: 0;
  height: 100%;
  overflow: hidden;
  bottom: 0;
  width: 100%;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/deep/#remoteHolder > video {
  border-radius: 12px;
}
#local-holder-overlay {
  position: absolute;
  left: 5px;
  top: 5px;
}
.video-description {
  margin: 0px;
  font-size: 2vw;
}
/deep/.localHolder-card {
  min-width: 20vw;
  border: none;
  border-radius: 12px;
}
/deep/#localHolder {
  background-color: #6d6f74;
  box-shadow: 0 0 20px black;
}

/deep/.local-video {
  width: 100%;
  height: 100%;
}

.local-audio {
}

/deep/.remote-video {
  /* min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  width: 100%;
  background-color: #606266;
}

.remote-audio {
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  padding: 0px;
}
/deep/.el-loading-mask {
  z-index: 0;
  border-radius: 12px;
}
.el-loading-spinner i {
  color: #1e95fa !important;
}

.el-loading-spinner .el-loading-text {
  color: #1e95fa !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

/** Media queries **/
@media screen and (min-width: 980px) {
  .video-description {
    font-size: 16px;
  }
}
@media screen and (max-width: 460px) {
  #recording-text {
    font-size: 0.8em;
  }
  .rec-notification.el-col-xs-15 {
    width: 80%;
    padding: 5px;
  }
  .rec-notification .el-notification__closeBtn.el-icon-close {
    top: 9px;
  }
  .rec-notification p {
    font-size: 0.8em;
  }
  .rec-notification i.el-notification__icon {
    font-size: 16px;
  }
  .rec-notification .el-notification__group {
    margin: 0px;
  }
}

/** Workaround styles **/
.svg-inline--fa.fa-w-11,
.svg-inline--fa.fa-w-20 {
  width: 1.125em;
}
.rec-notification .el-notification__content {
  margin: 0px;
}

/** Animations **/
@keyframes blink {
  50% {
    opacity: 0;
  }
}
.blink {
  animation: blink 1s step-end infinite;
  -webkit-animation: blink 1s step-end infinite;
}
</style>

<style scoped>
.height-100 {
  height: 100%;
}
</style>
